import { Word } from '@attain-apps/string-builder'
import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

import type * as ecModels from '../../../../models'

/**
 * Specific {@link ecModels.EntityId} that represents an entity that is being
 * created
 *
 * Identified by {@link CreationId.PREFIX}
 */
export type CreationId = Satisfies<
  `${typeof CreationId.PREFIX}${string}`,
  ecModels.EntityId
>
export namespace CreationId {
  export const isCreationId: TypeChecker<CreationId> =
    TypeChecker.Factory.custom(
      (val): val is CreationId =>
        typeof val === 'string' && val.startsWith(CreationId.PREFIX),
      {
        typeDescription: 'CreationId',
      },
    )

  export const assertIsCreationId: TypeAsserter<CreationId> =
    TypeAsserter.Factory.from(isCreationId)

  /**
   * Prefix for {@link CreationId}
   *
   * __NOTE:__ must be unique, so it doesn't collide with
   * {@link models.EntityId}
   */
  export const PREFIX = '§¤'

  /**
   * Generates a {@link CreationId}.
   *
   * If `entityId` is provided, the result is deterministic: `PREFIX + entityId`.
   * Otherwise a random suffix is generated.
   */
  export function generate(params?: {
    entityId?: ecModels.EntityId
  }): CreationId {
    return `${PREFIX}${params?.entityId ?? Word.generate()}`
  }
}
